module.exports = __webpack_public_path__ + "static/media/acessibilidade.d6d91aa4.png";